<section>
  <uilab-app-bar
    [appName]="appComponentService.config.appHeaderTitle"
    [userMenuOptions]="userMenuOptions"
    (toggleMobileNav)="toggleMobileNav($event)"
    (menuItemSelected)="menuItemSelected($event)"
    [isLoggedIn]="true"
    [legal]="legal"
    [userMenuOptions]="userMenuOptions"
    class="uilab-app-bar"
  ></uilab-app-bar>
</section>

<section class="uilab-layout-container">
  <section class="uilab-layout-nav">
    <uilab-nav-rail
      class="uilab-nav-rail"
      subMenuType="sidesheet"

      [items]="navRail"
      [collapsed]="collapsed()"
      [attr.aria-expanded]="collapsed()"
      [activeRoute]="activeRoute"
      [toggleMobileMenu]="mobileMenu"

      (menuItemSelected)="navigateToPage($event.linkData?.href)"
      (mobileMenuStatus)="toggleMobileNav($event)"
      (collapsedEmitter)="persistNavRailState($event)"
    >
    </uilab-nav-rail>
  </section>

  <main class="uilab-main-canvas">
    <router-outlet></router-outlet>
  </main>
</section>